const CHUNK_ERROR_PATTERN =
  /(ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported module)/i;

const RELOAD_GUARD_KEY = "__chunk_reload_attempted__";

export const isChunkLoadError = (error) => {
  if (!error) return false;
  const message =
    error?.message ||
    error?.reason?.message ||
    error?.toString?.() ||
    "";
  return CHUNK_ERROR_PATTERN.test(message);
};

export const tryRecoverFromChunkError = (error) => {
  if (!isChunkLoadError(error)) return false;
  if (sessionStorage.getItem(RELOAD_GUARD_KEY) === "1") return false;
  sessionStorage.setItem(RELOAD_GUARD_KEY, "1");
  window.location.reload();
  return true;
};

export const clearChunkReloadGuard = () => {
  sessionStorage.removeItem(RELOAD_GUARD_KEY);
};

